import { render } from "./TabNavComponent.vue?vue&type=template&id=0e97d554&scoped=true"
import script from "./TabNavComponent.vue?vue&type=script&lang=js"
export * from "./TabNavComponent.vue?vue&type=script&lang=js"

import "./TabNavComponent.vue?vue&type=style&index=0&id=0e97d554&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e97d554"]])

export default __exports__